import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footerWrap">
      <div className="footerInner">
        <div className="footerCol">
          <div className="footerBrand">ayrine</div>
          <p className="footerText">
            Minimal, elegant collections — jewellery, wear, and everyday essentials.
          </p>
        </div>

        <div className="footerCol">
          <div className="footerTitle">Quick Links</div>
          <Link to="/" className="footerLink">Home</Link><br />
          <Link to="/contact" className="footerLink">Contact</Link>
        </div>

        <div className="footerCol">
          <div className="footerTitle">Collections</div>
          <Link to="/collections/jewellery" className="footerLink">Jewellery</Link><br />
          <Link to="/collections/traditional-western" className="footerLink">
            Traditional &amp; Western Wear
          </Link><br />
          <Link to="/collections/bags-purses" className="footerLink">Bags &amp; Purses</Link>
        </div>

        {/* ✅ NEW: Policies */}
        <div className="footerCol">
          <div className="footerTitle">Policies</div>
          <Link to="/terms-and-conditions" className="footerLink">Terms &amp; Conditions</Link><br />
          <Link to="/privacy-policy" className="footerLink">Privacy Policy</Link><br />
          <Link to="/cancellation-refund-policy" className="footerLink">
            Cancellation &amp; Refund Policy
          </Link><br />
          <Link to="/shipping-policy" className="footerLink">Shipping Policy</Link>
        </div>

        <div className="footerCol">
          <div className="footerTitle">Support</div>
          <span className="footerText">Email: info@Ayrine.in</span>
          <span className="footerText">Contact:+91 9885881181</span>
        </div>
      </div>

      <div className="footerBottom">
        <span>© {new Date().getFullYear()} ayrine. All rights reserved.</span>
        <a
          href="https://vrnd.tech"
          target="_blank"
          rel="noopener noreferrer"
          className="poweredBtn"
        >
          Crafted by VRND Business Solutions
        </a>
      </div>
    </footer>
  );
}